import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Clothing from "../pages/Categories/clothing";
import Cart from "../pages/cart";
import ProductDetails from "../pages/productdetails";
import AboutUs from "../pages/AboutUs";
import ContactUs from "../pages/ContactUs";
import OrderPlace from "../pages/OrderPlace";
import Profile from "../pages/Profile";
import AllOrders from "../pages/AllOrder";
import Wishlist from "../pages/Wishlist";
import Checkout from "../pages/Checkout";
import AllProductData from "../pages/AllProductData";
import ViewAllCategory from "../pages/Categories/ViewAllCategory";
import ShowSubCategoryData from "../pages/Categories/ShowSubCategory";
import Login from "../pages/Login";
import Register from "../pages/NavBar/Register";
import { v4 as uuidv4 } from "uuid";
import ShowCategoryData from "../pages/Categories/ShowCategoryData";
import ShowSubCategory from "../pages/Categories/ShowSubCategory";
import ReturnPolicy from "../FooterInformation.jsx/ReturnPolicy";
import Delivery from "../FooterInformation.jsx/Delivey";
import ShippingPolicy from "../FooterInformation.jsx/ShippingPolicy";
import PaymentPolicy from "../FooterInformation.jsx/PaymentsPolicy";
import DisclaimerPolicy from "../FooterInformation.jsx/DisclaimerPolicy";
import PrebookingPolicy from "../FooterInformation.jsx/PrebookingPolicy";
import RefundReturn from "../FooterInformation.jsx/Refund&Return";
import TermsOfServices from "../FooterInformation.jsx/TermsOfServices";
import PrivacyPolicy from "../FooterInformation.jsx/PrivacyPolicy";
import FAQ from "../FooterInformation.jsx/FAQ";
import UseIt from "../FooterInformation.jsx/UseIt";
import Coupons from "../pages/Coupons";
import SellerDashboard from "../pages/SellerPages/SellerDashboard";
import SellerRegister from "../pages/SellerPages/SellerRegister";
import GstRegistration from "../pages/SellerPages/GstRegistration";
import SellerLogin from "../pages/SellerPages/SellerLogin";
import ThankYouPage from "../pages/ThankYouPage";
import TopSellDetails from "../pages/TopSellDetails";
import CancelAndReturn from "../FooterInformation.jsx/cancelandreturn";
import PaymentCallbackPage from "../pages/PaymentCallbackPage";
import PaymentResultPage from "../pages/PaymentResultPage";
import SearchProductResult from "../pages/SearchProduct";
import RemoteSale from "../pages/remotesale";
import ACsale from "../pages/ACsale";
import WatchSale from "../pages/WatchSale";
import PageNotFound from "../pages/PageNotFound";
import BlogDetails from "../pages/BlogDetails";
import Blogs from "../pages/Blogs";
import RequestCallback from "../pages/RequestCallback";

function AppRoute() {
  // useEffect(() => {
  //   const LoginData = localStorage.getItem("loginData");
  //   if (LoginData) {
  //     localStorage.removeItem("uuid");
  //   } else {
  //     let storedUuid = localStorage.getItem("uuid");
  //     if (!storedUuid) {
  //       storedUuid = uuidv4();
  //       localStorage.setItem("uuid", storedUuid);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    const LoginData = localStorage.getItem("loginData");
    if (LoginData) {
      localStorage.removeItem("uuid");
      localStorage.removeItem("uuidTimestamp");
    } else {
      const storedUuid = localStorage.getItem("uuid");
      const storedTimestamp = localStorage.getItem("uuidTimestamp");

      const now = Date.now();
      const twentyFourHours = 24 * 60 * 60 * 1000;

      if (
        !storedUuid ||
        !storedTimestamp ||
        now - parseInt(storedTimestamp) > twentyFourHours
      ) {
        const newUuid = uuidv4();
        localStorage.setItem("uuid", newUuid);
        localStorage.setItem("uuidTimestamp", now.toString());
      }
    }
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/product-category/:Catenames/:Cateid"
        element={<ShowCategoryData />}
      />
      <Route
        path="/ShowSubCategory/:Catename/:SubCategoryProps/:Cateid"
        element={<ShowSubCategory />}
      />
      <Route path="/Clothing" element={<Clothing />} />
      <Route path="/Cart" element={<Cart />} />
      <Route
        path="/shop/:category/:subcategory/:title"
        element={<ProductDetails />}
      />
      <Route path="/AllProductData" element={<AllProductData />} />
      <Route path="/about-us/" element={<AboutUs />} />
      <Route path="/contact-us/" element={<ContactUs />} />
      <Route path="/OrderPlace" element={<OrderPlace />} />
      <Route path="/track-your-order/" element={<AllOrders />} />
      <Route path="/Wishlist" element={<Wishlist />} />
      <Route path="/Checkout" element={<Checkout />} />
      <Route path="/all-cate" element={<ViewAllCategory />} />
      <Route path="/ShowSubCategoryData" element={<ShowSubCategoryData />} />
      <Route path="/Profile" element={<Profile />} />
      <Route path="/my-account/" element={<Login />} />
      <Route path="/Register" element={<Register />} />
      <Route path="/return-policy/" element={<ReturnPolicy />} />
      <Route path="/delivery-information/" element={<Delivery />} />
      <Route path="/shipping-policy/" element={<ShippingPolicy />} />
      <Route path="/pricing-and-payments-policy/" element={<PaymentPolicy />} />
      <Route path="/disclaimer-policy/" element={<DisclaimerPolicy />} />
      <Route
        path="/prebooking-terms-and-conditions/"
        element={<PrebookingPolicy />}
      />
      <Route path="/refund-return/" element={<RefundReturn />} />
      <Route path="/terms-of-service/" element={<TermsOfServices />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/faq/" element={<FAQ />} />
      <Route path="/how-to/" element={<UseIt />} />
      <Route path="/Coupons" element={<Coupons />} />
      <Route path="/vendor-register/" element={<SellerDashboard />} />
      <Route path="/SellerRegister" element={<SellerRegister />} />
      <Route path="/GstRegistration" element={<GstRegistration />} />
      <Route path="/SellerLogin" element={<SellerLogin />} />
      <Route path="/ThankYouPage" element={<ThankYouPage />} />
      <Route
        path="/topSale/:category/:subcategory/:title"
        element={<TopSellDetails />}
      />
      <Route
        path="/remotesale/:category/:subcategory/:title"
        element={<RemoteSale />}
      />
      <Route
        path="/acsale/:category/:subcategory/:title"
        element={<ACsale />}
      />
      <Route
        path="/watchsale/:category/:subcategory/:title"
        element={<WatchSale />}
      />

      <Route
        path="/cancellation-and-return-policy/"
        element={<CancelAndReturn />}
      />
      <Route path="/users/verify-payment" element={<PaymentCallbackPage />} />
      <Route path="/paymentResultPage" element={<PaymentResultPage />} />
      <Route path="/searchProduct" element={<SearchProductResult />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/Blogs/:category/:title" element={<BlogDetails />} />
      <Route path="*" element={<PageNotFound />} />
      <Route path="/requestCallback" element={<RequestCallback />} />

      {/* RequestCallback */}
    </Routes>
  );
}

export default AppRoute;
